module.exports = __webpack_public_path__ + "static/media/arrows-alt.30a185d4.svg";